import React from "react";
import Container from "../Container";
import style from "./style.module.css";
import { ReactComponent as Logo } from "../Icons/avantStayLogo.svg";

function Header() {
  return (
    <header className={style.header}>
      <Container className={style.container}>
        <a href={process.env.REACT_APP_SITE_URL}>
          <Logo className={style.logo} />
        </a>
        <button className={style.printButton} onClick={window.print}>
          Print
        </button>
      </Container>
    </header>
  );
}

export default Header;
